import Vue from 'vue'
import Router from 'vue-router'
import { getRequestParams, decodeFromBase64 } from '@/utils/getPrams.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // 共三个页面： 聊天页面，好友页面，个人简历分别对应一下路由
  routes: [
    // 默认路由重定向到登录页面
    // {
    //   path: '/',
    //   redirect: '/login'
    // },
    {
      path: '/login',
      component: () => import('@/page/login/login.vue')
    },
    {
      path: '/chat',
      component: () => import('@/page/chat/chat.vue')
    },

  ],
  linkActiveClass: 'active'
})


// 添加路由守卫
router.beforeEach((to, from, next) => {
  // 获取并处理URL参数
  const urlParams = getRequestParams();
  //console.log('路由守卫 - 当前路径:', to.path);
  //console.log('路由守卫 - URL参数:', urlParams);
  
    // 只有明确配置的路径才能被访问
  const allowedPaths = ['/login', '/chat'];
  
  // 如果是允许的路径，直接通过
  if (allowedPaths.includes(to.path)) {
    next();
    return;
  }
  
  // 处理根路径或其他未配置路径
  // 优先检查URL参数以确定正确的跳转目标
  if (urlParams) {
    try {
      const decodedParams = decodeURIComponent(urlParams);
      //console.log('路由守卫 - 解码后的URL参数:', decodedParams);
      
      const authObj = JSON.parse(Buffer.from(decodedParams, 'base64').toString());
      //console.log('路由守卫 - authObj:', authObj);
      
      if (authObj && typeof authObj === 'object' && authObj.type !== undefined) {
        const type = String(authObj.type);
        const targetPath = type === '2' ? '/chat' : '/login';
        
        // 跳转到目标路径，不携带参数
        next({ path: targetPath+'?'+urlParams });
        return;
      }
    } catch (error) {
      console.error('路由守卫 - 解析URL参数错误:', error);
    }
  }

  
  // 默认跳转到登录页面
  next({ path: '/login' });
});

export default router